import { useCallback, useState } from 'react';

import { getRides } from '../../../api/services/Riders';
import { RIDE_STATES_QUERY } from '../../../constants';
import { useTimezone } from '../../../hooks/useTimezone';

import { RideForRiderCentric } from './types';

interface IUseRidesForRider {
  rides: RideForRiderCentric[];
  loading: boolean;
  fetchRides: (query: QueryParams) => void;
  getDateForState: (date: Date, state: string) => string;
}

export const useRidesForRider = (id: string, isSharedBillingRider: boolean): IUseRidesForRider => {
  // rides are the current state of the query
  const [rides, setRides] = useState<RideForRiderCentric[]>([]);
  const [loading, setLoading] = useState(true);

  const { getEndOfDate, getStartOfDate } = useTimezone();

  const fetchRides = useCallback(
    async (queryParams: QueryParams) => {
      setLoading(true);

      const response = await getRides(id, queryParams);

      if (response?.type === 'success' && response.data.trips) {
        setRides(response.data.trips);
        setLoading(false);
      } else {
        setLoading(false);
      }
    },
    [isSharedBillingRider]
  );

  const getDateForState = (date, state) => {
    return date
      ? ([RIDE_STATES_QUERY.upcoming, RIDE_STATES_QUERY.requested].indexOf(state) !== -1
          ? getStartOfDate(date)
          : getEndOfDate(date)
        ).toISOString()
      : date;
  };

  return { rides, loading, fetchRides, getDateForState };
};
